import { z } from "zod";

export const getEmploymentSchema = z.object({
	employmentId: z.string(),
	userId: z.string().nonempty(),
});

export type GetEmploymentSchema = z.infer<typeof getEmploymentSchema>;
